import { render, staticRenderFns } from "./AddQuotation.vue?vue&type=template&id=5c93653d&"
import script from "./AddQuotation.vue?vue&type=script&lang=js&"
export * from "./AddQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports